<router-outlet></router-outlet>

<p-toast position="bottom-center">
    <ng-template let-message pTemplate="message">
        <div class="ml-4">
            <div class="">
                <span class="font-medium-large fw-bold color-white">{{message.summary | translate}}</span>
            </div>
            <div class="mt-7 mb-1">
                <span class="font-medium-large color-white">{{message.detail | translate}}</span>
            </div>
        </div>
    </ng-template>
</p-toast>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "ball-newton-cradle" [fullScreen] = "true">
    <p style="color: white" > {{ "LOADING" | translate }}... </p>
</ngx-spinner>